import { useEffect } from 'react';

import { ModalProps, useTheme } from '@material-ui/core';
import { FiX } from 'react-icons/fi';

import { useLocale } from 'shared/presentation/contexts';

import {
  CloseButton,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalWrapper,
} from './styles';
import Button from '../button';

const TIMEOUT = 40 /* seconds */ * 1000;

type TModalProps = ModalProps & {
  actionLabel?: string;
  showCloseButton?: boolean;
};

const Modal = ({
  children,
  open,
  onClose,
  actionLabel,
  showCloseButton = false,
}: TModalProps) => {
  const theme = useTheme();
  const { t } = useLocale('translations');

  useEffect(() => {
    if (open) {
      const timer = setTimeout(() => {
        if (onClose) onClose({}, 'backdropClick');
      }, TIMEOUT);

      return () => clearTimeout(timer);
    }
  }, [open, onClose]);

  return (
    <ModalWrapper open={open} onClose={onClose}>
      <ModalBody>
        {showCloseButton && (
          <CloseButton
            type="button"
            aria-label={t('components.modal.actions.close')}
            onClick={e => onClose && onClose(e, 'backdropClick')}
          >
            <FiX />
          </CloseButton>
        )}
        <ModalContent>{children}</ModalContent>
        <ModalFooter>
          <Button
            dataCy="backButton"
            bordercolor={theme.colors.primary}
            onClick={e => onClose && onClose(e, 'backdropClick')}
          >
            {actionLabel || t('components.modal.actions.cancel')}
          </Button>
        </ModalFooter>
      </ModalBody>
    </ModalWrapper>
  );
};

export default Modal;
